export default __webpack_public_path__ + "static/media/account.5bbe3537.svg";